import { loan_quote } from '@axo/shared/data-access/types';

export function formatDuration(item: loan_quote.BankQuote) {
  return `${item.Duration ?? 0}y ${
    item.DurationMonths ? `${item.DurationMonths}m` : ''
  }`;
}
